import { getCookie } from 'bv';
import { CurrencyFormatId } from './currency_format_id';

export default () => (
  parseInt(getCookie('price_format_id'), 10) || CurrencyFormatId.FRACTIONAL
);
